import React from "react";
import { PollData_Layout_PollLayout_Type } from "./../../../ricos-schema/legacy/wix/rich_content/v1";
import { withRCEHelpers } from "../rce-helpers-context";
import { PollGridOption } from "./PollGridOption";
import { PollListOption } from "./PollListOption";
import { PollGridOptionWebview } from "./webview/PollGridOptionWebview";
import { PollListOptionWebview } from "./webview/PollListOptionWebview";
import { OptionPropTypes } from "./types";
const PollOption = withRCEHelpers((props) => {
  const { layout, rce } = props;
  if (rce.isWebView) {
    switch (layout.poll?.type) {
      case PollData_Layout_PollLayout_Type.GRID:
        return /* @__PURE__ */ React.createElement(PollGridOptionWebview, { ...props });
      case PollData_Layout_PollLayout_Type.LIST:
      default:
        return /* @__PURE__ */ React.createElement(PollListOptionWebview, { ...props });
    }
  }
  switch (layout.poll?.type) {
    case PollData_Layout_PollLayout_Type.GRID:
      return /* @__PURE__ */ React.createElement(PollGridOption, { ...props });
    case PollData_Layout_PollLayout_Type.LIST:
    default:
      return /* @__PURE__ */ React.createElement(PollListOption, { ...props });
  }
});
export {
  OptionPropTypes,
  PollOption
};
//# sourceMappingURL=index.js.map
